import React, { useState } from "react";
import { View, ScrollView, Text, TouchableOpacity } from "react-native";

import appStyles from "../../../../appStyles";
import {
  downloadOrEmailURL,
  openURL,
  isWeb,
  sendDownloadEmail,
} from "../../../../../helpers/utils";

import GuidesIcon from "../../../common/icons/more/GuidesIcon";
import ManaIcon from "../../../common/icons/ManaIcon";

import styles from "../integrationStyles";
import IntegrationsHelper from "../../IntegrationsHelper";
import AppConfig from "../../../../../config/AppConfig";
import steps from "../steps";
import IntegrationIcons from "../../../common/icons/integrations/index";
import LoadingIndicator from "../../../common/LoadingIndicator";
import CarouselProgressBar from "../../../animation/progressBar/CarouselProgressBar";
import ProgressBarConfig from "../../../animation/progressBar/config";
import ManaButton from "../../../common/ManaButton";

export default function DesktopIntegration({
  controller,
  isFromCard = false,
  goToStep = () => {},
}) {
  const [isLoading, setIsLoading] = useState(false);
  const currentScreenIndex = ProgressBarConfig["integrationsDesktop"];
  const numberOfScreens = Object.keys(ProgressBarConfig).length;

  const downloadDesktopApp = (env) => {
    const data = {
      [IntegrationsHelper.DESKTOP_SYNC_KEY]: true,
    };

    setIsLoading(true);
    IntegrationsHelper.saveIntegrations(
      controller,
      data,
      () => {
        setIsLoading(false);
        goToStep(steps.desktopAdded);
        downloadOrEmailURL(controller, env, AppConfig[`${env}_DOWNLOAD_URL`]);
      },
      () => setIsLoading(false),
    );
  };

  const goBack = () => {
    if (isFromCard) {
      controller.goBack();
    } else {
      goToStep(steps.calendar);
    }
  };

  const skip = () => {
    sendDownloadEmail(controller, "WIN");
    goToStep(isWeb ? steps.checklist : steps.health);
  };

  return (
    <>
      <LoadingIndicator isLoading={isLoading} />

      <CarouselProgressBar
        currentScreenIndex={currentScreenIndex}
        numberOfScreens={numberOfScreens}
        changeScreen={goBack}
        hideNext
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.header}>Let’s connect!</Text>

        {/* Connect */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>
            Once we connect to your desktop, we can:
          </Text>

          <View style={styles.row}>
            <IntegrationIcons.WandGradientIcon
              style={styles.icon}
              width={30}
              height={30}
            />

            <Text style={styles.rowText}>
              Automatically track time spent in applications
            </Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.TrendsIcon style={styles.icon} />

            <Text style={styles.rowText}>
              Understand your work habits and trends
            </Text>
          </View>
          <View style={styles.row}>
            <GuidesIcon style={styles.icon} width={30} height={30} />

            <Text style={styles.rowText}>
              Provide custom insights to help optimize how you spend screen-time
              on your desktop
            </Text>
          </View>
        </View>

        {/* Safety */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Hold on, is this safe?</Text>

          <View style={styles.row}>
            <IntegrationIcons.MetricsIcon style={styles.icon} />

            <Text style={styles.rowText}>
              Choose which metrics to share with us
            </Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.PersonalIcon style={styles.icon} />

            <Text style={styles.rowText}>Revoke sharing at any time</Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.DollarIcon
              style={styles.icon}
              width={30}
              height={30}
            />

            <Text style={styles.rowText}>
              We’re not in the business of selling your data - that’s a promise
              that sets us apart.
            </Text>
          </View>

          <View style={styles.row}>
            <ManaIcon style={styles.icon} width={30} height={30} />

            <Text
              style={(styles.rowText, styles.link)}
              onPress={() => {
                openURL(AppConfig.PRIVACY_LINK);
              }}
            >
              Tap here for more on privacy at Mana
            </Text>
          </View>
        </View>
      </ScrollView>

      {/* Desktop buttons */}
      {isWeb ? (
        <View
          style={[appStyles.footerButtons, appStyles.verticalFooterButtons]}
        >
          <TouchableOpacity
            onPress={() => downloadDesktopApp("MAC")}
            style={[styles.button, { width: 207 }]}
          >
            <IntegrationIcons.MacIcon
              width={14}
              height={14}
              style={styles.buttonIcon}
            />
            <Text style={styles.buttonText}>Get Mana Sync for Mac</Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => downloadDesktopApp("WIN")}
            style={[styles.button, { width: 207 }]}
          >
            <IntegrationIcons.WindowsIcon
              width={14}
              height={14}
              style={styles.buttonIcon}
            />
            <Text style={styles.buttonText}>Get Mana Sync for PC</Text>
          </TouchableOpacity>

          <Text style={styles.skipText} onPress={skip}>
            Skip for now
          </Text>
        </View>
      ) : (
        /* Mobile button */
        <View style={[appStyles.footerButtons]}>
          <ManaButton
            isMainButton
            text={"Continue"}
            style={appStyles.bottomButton}
            styleText={appStyles.bottomButtonText}
            onPress={skip}
          />
        </View>
      )}
    </>
  );
}
